import { render, staticRenderFns } from "./AssetProperties.vue?vue&type=template&id=288e37bf&scoped=true&"
import script from "./AssetProperties.vue?vue&type=script&lang=js&"
export * from "./AssetProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e37bf",
  null
  
)

export default component.exports